
<div class="wrapper">
  <section id="esqueci-senha">
    <div class="container area-faca-parte">
      <form class="sample-form" method="post" target="_top">
        <div class="body-faca-parte columns">
          <div class="column is-full">

            <div class="dados-pessoais text-center">

              <h3>Tudo certo com sua senha, Pedro!</h3>
              <p>
                <strong>Seja Muito Bem-vindo ao Clube Montreal</strong>
                <br>
                Separei algumas Dicas para você Aproveitar Tudo o que nós temos para te oferecer. É só Clicar no Assunto que te interessar primeiro!
              </p>

              <div class="area-pdf">
                <a href="">
                  <img class="icons-onboarding" width=64 height=64 src="assets/img/icon-destinos.png">
                  <i class="far fa-external-link-alt"></i>
                  <p><strong>Destinos e Hotéis</strong></p>
                  <p>As Melhores Ideias e Roteiros para suas Viagens com o Clube!</p>
                </a>
              </div>

              <div class="area-pdf">
                <a href="">
                  <img class="icons-onboarding" width=64 height=64 src="assets/img/icon-member-get-member.png">
                  <i class="far fa-external-link-alt"></i>
                  <p><strong>Indique e Ganhe</strong></p>
                  <p>Convide seus Amigos e Ganhe Dinheiro, direto na sua Conta Bancária!</p>
                </a>
              </div>

              <div class="area-pdf">
                <a href="">
                  <img class="icons-onboarding" width=64 height=64 src="assets/img/icon-montreal-mais.png">
                  <i class="far fa-external-link-alt"></i>
                  <p><strong>Montreal+</strong></p>
                  <p>Conheça outras Vantagens do nosso Clube de Hospedagem!</p>
                </a>
              </div>

              <h4 id="sobre-o-clube" class="text-center">Agência de Viagem</h4>

              <p>Nós também temos um Portal de Pesquisa e Compra de Passagens e Aluguel de Carros, sabia? Com o nosso Buscador, você sempre encontrará os Menores Preços do mercado. Um verdadeiro Guru!</p>

              <a class="btn-ideia" href="">Clica Aqui para conhecer o Guru Viagens!</a>

              <h5>Quer entender melhor o seu Novo Clube? Só Clicar nos links abaixo!</h5>

              <div class="area-pdf">
                <a href="">
                  <img class="icons-onboarding" width=64 height=64 src="assets/img/icon-como-funciona.png">
                  <i class="far fa-external-link-alt"></i>
                  <p><strong>Como Funciona?</strong></p>
                  <p>A nossa página de Como Funciona aborda tudo que você precisa saber, desde a aquisição até sua viagem!</p>
                </a>
              </div>

              <div class="area-pdf">
                <a href="">
                  <img class="icons-onboarding" width=64 height=64 src="assets/img/icon-duvidas.png">
                  <i class="far fa-external-link-alt"></i>
                  <p><strong>Dúvidas Frequentes</strong></p>
                  <p>Nestes mais de 30 anos de serviço, montamos uma lista das Principais Dúvidas que nossos Novos Clientes costumam ter.</p>
                </a>
              </div>

              <div class="area-pdf">
                <a href="">
                  <img class="icons-onboarding" width=64 height=64 src="assets/img/icon-chat.png">
                  <i class="far fa-external-link-alt"></i>
                  <p><strong>Fale Conosco</strong></p>
                  <p>Nossos principais Canais de Contato num mesmo lugar. Atendimento a jato, do jeito que Você Preferir!</p>
                </a>
              </div>

              <div class="card-contatos">
                <h5>Contatos</h5>
                <div class="meio">
                  <p><strong>Televendas</strong></p>
                  <p>0800 000 000</p>
                  <p><strong>Whatsapp</strong></p>
                  <p>61 0000-000</p>
                  <p><strong>E-mail</strong></p>
                  <p>montreal@montreal.com.br</p>
                </div>
              </div>

              <h4>Não tem mais dúvidas? Então Acesse o Portal do Cliente Clicando no Botão Abaixo!</h4>

              <a href="" class="btn-verde" type="submit">IR PARA O PORTAL DO CLIENTE</a>

              <a class="btn-ideia" href="">Ideias para sua próxima viagem</a>

            </div>



          </div>

        </div>


      </form>
    </div>
  </section>

</div>


